
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Pictures/[id]",
      function () {
        return require("private-next-pages/Pictures/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Pictures/[id]"])
      });
    }
  